module.exports = __webpack_public_path__ + "img/cardGallery4.jpg?a2078388f4129f91ccb1230b0e947ea0";